<template>
  <section>
    <!-- <v-divider class="mt-4 mb-2"></v-divider> -->

    <v-subheader>Author Menu</v-subheader>

    <v-list-item class="mb-1" to="/manuscripts/start">
      <v-list-item-icon>
        <v-icon>mdi-upload-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Submit Manuscript</v-list-item-title>
    </v-list-item>

    <v-list-item class="mb-1" to="/manuscripts/incomplete">
      <v-list-item-icon>
        <v-badge
          color="red"
          v-if="incompleteSubmissions"
          :content="incompleteSubmissions"
          class="d-block green--text mt-4 ml-1"
        ></v-badge>
        <v-icon v-else>mdi-progress-upload</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title> Incomplete Submissions </v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-list-item class="mb-1" to="/manuscripts/submitted">
      <v-list-item-icon>
        <v-icon>mdi-folder-multiple-outline</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Submitted Manuscripts</v-list-item-title>
    </v-list-item>
  </section>
</template>


<script>
export default {
  data: () => ({
    incompleteSubmissions: 0,
  }),

  methods: {
    async fetchIncompleteSubmissions() {
      const {
        data: { count },
      } = await this.$axios.get(`/briefs/incomplete`);
      this.incompleteSubmissions = count;
    },
  },

  mounted() {
    this.fetchIncompleteSubmissions();
    this.$bus.$on("manuscript.refresh", this.fetchIncompleteSubmissions);
  },
};
</script>